import { render, staticRenderFns } from "./permissionGrant.vue?vue&type=template&id=54dd2b45&scoped=true&"
import script from "./permissionGrant.vue?vue&type=script&lang=ts&"
export * from "./permissionGrant.vue?vue&type=script&lang=ts&"
import style0 from "./permissionGrant.vue?vue&type=style&index=0&id=54dd2b45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dd2b45",
  null
  
)

export default component.exports